module.exports = __webpack_public_path__ + "new3.025bae52.png";